import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { ModalProps } from "types/utils/modal";

export const SendDraftToCustomerConfirmation = ({
  isOpen,
  close,
  onSend,
}: { onSend: () => void } & ModalProps) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <Modal.Header>
          <Modal.Title>All Fields Checked?</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-text-text-60 t-text-body-sm">
            This draft is about to be sent for customer verification. Have you
            checked all fields for accuracy?
          </div>
        </Modal.Body>

        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Review again</Button>
          </Modal.RawClose>
          <Button customType="primary" onClick={onSend}>
            Yes, send to customer
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
